import { getUserDetails } from "../../services/users/userService";
// An approval actor is not the source writer or the signer of an original.
export const hydrateKnowledgeFactApprovals = async (
  facts,
  lookupUser = getUserDetails,
) => {
  const users = new Map();
  const read = (id) => {
    if (!users.has(id))
      users.set(
        id,
        Promise.resolve()
          .then(() => lookupUser(id))
          .catch(() => null),
      );
    return users.get(id);
  };
  return Promise.all(
    facts.map(async (fact) => {
      const ref = (fact.sourceRefs || []).find(
        (ref) => ref.confirmedBy && ref.confirmedAt,
      );
      const reviewedBy = fact.reviewedBy || ref?.confirmedBy;
      const reviewedAt = fact.reviewedAt || ref?.confirmedAt;
      if (!reviewedBy || !reviewedAt) return fact;
      const user = fact.reviewedByName ? null : await read(reviewedBy);
      const resolved =
        user?.uid === reviewedBy && user.displayName !== "Unknown User"
          ? user.displayName || user.name
          : "";
      return {
        ...fact,
        reviewedBy,
        reviewedAt,
        reviewedByName: fact.reviewedByName || resolved || "",
      };
    }),
  );
};
